(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tdc-card-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tdcCardInit) return;
    window.__tdcCardInit = true;

    function variantsOf(card) {
      if (!card._tdcVariants) {
        var el = card.querySelector('[data-tdc-variants]');
        try { card._tdcVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._tdcVariants = []; }
      }
      return card._tdcVariants;
    }

    function findVariant(card, size) {
      var ci = parseInt(card.dataset.colorIndex, 10);
      var si = parseInt(card.dataset.sizeIndex, 10);
      var color = card.dataset.color;
      var list = variantsOf(card);
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (!v[2]) continue;
        if (ci > -1 && v[1][ci] !== color) continue;
        if (si > -1 && size && v[1][si] !== size) continue;
        return v;
      }
      return null;
    }

    function refreshSizes(card) {
      card.querySelectorAll('[data-tdc-qa-size]').forEach(function (btn) {
        var v = findVariant(card, btn.getAttribute('data-tdc-qa-size'));
        btn.disabled = !v;
        btn.setAttribute('data-variant', v ? v[0] : '');
      });
    }

    function selectSwatch(sw) {
      var card = sw.closest('[data-tdc-card]');
      if (!card || sw.classList.contains('is-active')) return;
      card.querySelectorAll('[data-tdc-sw]').forEach(function (b) {
        var on = b === sw;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      card.dataset.color = sw.getAttribute('data-value');
      var img = card.querySelector('.tdc-card__img');
      if (img && sw.dataset.src) {
        img.removeAttribute('loading');
        if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
        img.src = sw.dataset.src;
      }
      if (sw.dataset.url) card.querySelectorAll('[data-tdc-card-link]').forEach(function (a) { a.href = sw.dataset.url; });
      refreshSizes(card);
    }

    function setCount(cart) {
      document.querySelectorAll('#cart-count, .tdc-cart__count, [data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
    }

    function addToBag(btn) {
      var card = btn.closest('[data-tdc-card]');
      var qa = btn.closest('[data-tdc-qa]');
      var msg = qa && qa.querySelector('[data-tdc-qa-msg]');
      var id = parseInt(btn.getAttribute('data-variant'), 10);
      if (!id) return;
      btn.classList.add('is-loading');
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          qa.classList.add('is-done');
          if (msg) msg.textContent = 'Added to bag';
          setTimeout(function () { qa.classList.remove('is-done'); if (msg) msg.textContent = ''; card.classList.remove('is-qa-open'); }, 2200);
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCount(cart);
          document.dispatchEvent(new CustomEvent('tdc:cart:updated', { detail: { cart: cart, variantId: id, source: 'quick-add' } }));
        })
        .catch(function (err) {
          if (msg) { msg.classList.add('is-error'); msg.textContent = (err && (err.description || err.message)) || 'Sorry, this size could not be added.'; }
        })
        .finally(function () { btn.classList.remove('is-loading'); });
    }

    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('[data-tdc-sw]');
      if (sw && window.matchMedia('(hover: hover)').matches) selectSwatch(sw);
    });
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-tdc-sw]');
      if (sw) { e.preventDefault(); selectSwatch(sw); return; }
      var toggle = e.target.closest('[data-tdc-qa-toggle]');
      if (toggle) {
        e.preventDefault();
        var card = toggle.closest('[data-tdc-card]');
        document.querySelectorAll('[data-tdc-card].is-qa-open').forEach(function (c) { if (c !== card) c.classList.remove('is-qa-open'); });
        card.classList.toggle('is-qa-open');
        return;
      }
      var qv = e.target.closest('[data-tdc-qv]');
      if (qv) {
        e.preventDefault();
        var app = qv.closest('[data-tdc-card]').querySelector('.qview-button');
        if (app) app.click();
        return;
      }
      var btn = e.target.closest('[data-tdc-qa-size]');
      if (btn) { e.preventDefault(); addToBag(btn); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tdc-card-facets-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tdcFxInit) return;
    window.__tdcFxInit = true;

    var LS_DESK = 'tdc-grid-cols';
    var LS_MOB = 'tdc-grid-cols-m';
    var RESTORE_KEY = 'tdc-fx-restore';
    var mq = window.matchMedia('(max-width: 749px)');
    var controller = null;

    function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
    function session(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; } }
    function roots() { return document.querySelectorAll('[data-tdc-fx-section]'); }
    function rootOf(el) { return el && el.closest ? el.closest('[data-tdc-fx-section]') : null; }

    /* Grid density */
    function applyCols(scope) {
      var d = store(LS_DESK), m = store(LS_MOB);
      (scope || document).querySelectorAll('[data-tdc-grid]').forEach(function (g) {
        if (d) g.setAttribute('data-cols', d);
        if (m) g.setAttribute('data-mcols', m);
      });
      (scope || document).querySelectorAll('[data-tdc-cols]').forEach(function (b) {
        var root = rootOf(b);
        var g = root && root.querySelector('[data-tdc-grid]');
        if (!g) return;
        var cur = b.hasAttribute('data-mobile') ? (g.getAttribute('data-mcols') || '2') : g.getAttribute('data-cols');
        b.setAttribute('aria-pressed', String(b.getAttribute('data-tdc-cols') === cur));
      });
    }

    /* Sticky offset under the (partly sticky) header */
    function headerBottom() {
      var h = document.querySelector('.tdc-header') || document.querySelector('#header-group');
      if (!h) return 0;
      return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var top = headerBottom();
        document.documentElement.style.setProperty('--tdc-fx-top', top + 'px');
        document.querySelectorAll('[data-tdc-fx]').forEach(function (fx) {
          fx.classList.toggle('is-stuck', window.scrollY > 0 && fx.getBoundingClientRect().top <= top + 1);
        });
        var btn = document.querySelector('.tdc-totop');
        if (btn) btn.classList.toggle('is-visible', window.scrollY > Math.max(1400, window.innerHeight * 2));
      });
    }

    function scrollToResults(root) {
      var y = root.getBoundingClientRect().top + window.scrollY - headerBottom();
      if (window.scrollY > y + 4) window.scrollTo({ top: y, behavior: 'instant' });
    }

    /* Sheet (phones) */
    function setOpen(root, open) {
      var fx = root.querySelector('[data-tdc-fx]');
      if (!fx) return;
      fx.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('tdc-fx-lock', open);
    }

    function closeDropdowns(except) {
      if (mq.matches) return;
      document.querySelectorAll('[data-tdc-fx] details[open]').forEach(function (d) { if (d !== except) d.open = false; });
    }

    /* AJAX filtering via the Section Rendering API */
    function buildUrl(form) {
      var u = new URL(form.getAttribute('action'), window.location.origin);
      var fixed = Array.from(u.searchParams.keys());
      var def = form.getAttribute('data-default-sort');
      new FormData(form).forEach(function (v, k) {
        v = String(v).trim();
        if (v === '' || fixed.indexOf(k) > -1) return;
        if (k === 'sort_by' && v === def) return;
        u.searchParams.append(k, v);
      });
      return u.pathname + u.search;
    }

    function sectionUrl(url, id) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', id);
      return u.toString();
    }

    function load(root, url, push) {
      var id = root.getAttribute('data-section-id');
      var fx = root.querySelector('[data-tdc-fx]');
      var state = {
        open: !!(fx && fx.classList.contains('is-open')),
        dds: Array.prototype.map.call(root.querySelectorAll('[data-tdc-fx] details[open]'), function (d) { return d.getAttribute('data-tdc-fx-key'); }),
        listTop: (root.querySelector('[data-tdc-fx-list]') || {}).scrollTop || 0
      };
      root.classList.add('is-loading');
      if (controller) controller.abort();
      controller = new AbortController();
      fetch(sectionUrl(url, id), { signal: controller.signal })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-tdc-fx-section]');
          if (!fresh) throw new Error('missing section');
          root.innerHTML = fresh.innerHTML;
          root.setAttribute('data-pages', '1');
          var nfx = root.querySelector('[data-tdc-fx]');
          if (state.open && mq.matches && nfx) {
            nfx.classList.add('is-open', 'no-anim');
            requestAnimationFrame(function () { requestAnimationFrame(function () { nfx.classList.remove('no-anim'); }); });
          } else if (!mq.matches) {
            document.documentElement.classList.remove('tdc-fx-lock');
          }
          state.dds.forEach(function (key) {
            root.querySelectorAll('[data-tdc-fx] details').forEach(function (d) { if (d.getAttribute('data-tdc-fx-key') === key && key !== 'sort_by') d.open = true; });
          });
          var list = root.querySelector('[data-tdc-fx-list]');
          if (list) list.scrollTop = state.listTop;
          applyCols(root);
          if (push) history.pushState({ tdcFx: true }, '', url);
          if (!state.open) scrollToResults(root);
          session(RESTORE_KEY, null);
          onScroll();
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; window.location.href = url; })
        .finally(function () { root.classList.remove('is-loading'); });
    }

    /* Load more */
    function loadMore(btn, done) {
      var root = rootOf(btn);
      if (!root) return;
      var url = btn.getAttribute('href');
      btn.classList.add('is-loading');
      btn.textContent = 'Loading…';
      return fetch(sectionUrl(url, root.getAttribute('data-section-id')))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-tdc-grid]');
          doc.querySelectorAll('[data-tdc-grid] > li').forEach(function (li) { grid.appendChild(li); });
          var fresh = doc.querySelector('[data-tdc-more]');
          var more = root.querySelector('[data-tdc-more]');
          if (fresh && more) more.innerHTML = fresh.innerHTML;
          root.setAttribute('data-pages', String((parseInt(root.getAttribute('data-pages'), 10) || 1) + 1));
          if (done) done();
        })
        .catch(function () { window.location.href = url; });
    }

    /* Scroll position restore when coming back from a product page */
    function saveRestore(root) {
      session(RESTORE_KEY, JSON.stringify({ url: window.location.href, pages: parseInt(root.getAttribute('data-pages'), 10) || 1, y: window.scrollY }));
    }
    function restore() {
      var raw = session(RESTORE_KEY);
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      var isBack = nav ? nav.type === 'back_forward' : (performance.navigation && performance.navigation.type === 2);
      var root = document.querySelector('[data-tdc-fx-section]');
      if (!root || !isBack || data.url !== window.location.href) return;
      var remaining = data.pages - 1;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      function step() {
        var btn = root.querySelector('[data-tdc-load-more]');
        if (remaining > 0 && btn) { remaining--; loadMore(btn, step); }
        else { window.scrollTo(0, data.y); session(RESTORE_KEY, null); }
      }
      step();
    }

    /* Events */
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('[data-tdc-fx-auto]')) return;
      var form = el.closest('[data-tdc-fx-form]');
      var root = rootOf(form);
      if (form && root) load(root, buildUrl(form), true);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-tdc-fx-form]');
      if (!form) return;
      e.preventDefault();
      var root = rootOf(form);
      if (root) load(root, buildUrl(form), true);
    });

    document.addEventListener('input', function (e) {
      var el = e.target;
      if (el.matches('[data-tdc-fx-search]')) {
        var q = el.value.trim().toLowerCase();
        el.closest('.tdc-fx__panel').querySelectorAll('[data-tdc-fx-opt]').forEach(function (li) {
          li.hidden = q !== '' && li.getAttribute('data-tdc-fx-opt').indexOf(q) === -1;
        });
        return;
      }
      var range = el.closest && el.closest('[data-tdc-fx-range]');
      if (range) {
        var panel = range.closest('.tdc-fx__panel');
        var lo = range.querySelector('[data-tdc-fx-range-min]');
        var hi = range.querySelector('[data-tdc-fx-range-max]');
        var max = parseFloat(range.getAttribute('data-max')) || 1;
        if (parseFloat(lo.value) > parseFloat(hi.value)) { if (el === lo) lo.value = hi.value; else hi.value = lo.value; }
        panel.querySelector('[data-tdc-fx-min]').value = parseFloat(lo.value) > 0 ? lo.value : '';
        panel.querySelector('[data-tdc-fx-max]').value = parseFloat(hi.value) < max ? hi.value : '';
        paintRange(range);
      }
    });

    function paintRange(range) {
      var lo = range.querySelector('[data-tdc-fx-range-min]');
      var hi = range.querySelector('[data-tdc-fx-range-max]');
      var fill = range.querySelector('[data-tdc-fx-range-fill]');
      var max = parseFloat(range.getAttribute('data-max')) || 1;
      if (!fill) return;
      fill.style.left = (parseFloat(lo.value) / max * 100) + '%';
      fill.style.right = (100 - parseFloat(hi.value) / max * 100) + '%';
    }

    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d.tagName === 'DETAILS' && d.open && d.closest('[data-tdc-fx]')) {
        closeDropdowns(d);
        var range = d.querySelector('[data-tdc-fx-range]');
        if (range) paintRange(range);
        var search = d.querySelector('[data-tdc-fx-search]');
        if (search && !mq.matches) search.focus({ preventScroll: true });
      }
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (!t.closest('[data-tdc-fx] details')) closeDropdowns(null);

      var link = t.closest('[data-tdc-fx-link]');
      if (link) { e.preventDefault(); var r1 = rootOf(link); if (r1) load(r1, link.getAttribute('href'), true); return; }

      var open = t.closest('[data-tdc-fx-open]');
      if (open) { setOpen(rootOf(open), true); return; }
      var close = t.closest('[data-tdc-fx-close]');
      if (close) { setOpen(rootOf(close), false); return; }

      var colsBtn = t.closest('[data-tdc-cols]');
      if (colsBtn) {
        var n = colsBtn.getAttribute('data-tdc-cols');
        store(colsBtn.hasAttribute('data-mobile') ? LS_MOB : LS_DESK, n);
        applyCols(document);
        return;
      }

      var more = t.closest('[data-tdc-load-more]');
      if (more) { e.preventDefault(); loadMore(more); return; }

      var totop = t.closest('.tdc-totop, [data-tdc-totop]');
      if (totop) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); return; }

      var cardLink = t.closest('[data-tdc-grid] a');
      if (cardLink) { var r2 = rootOf(cardLink); if (r2) saveRestore(r2); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDropdowns(null);
      roots().forEach(function (r) { setOpen(r, false); });
    });

    window.addEventListener('popstate', function (e) {
      var root = document.querySelector('[data-tdc-fx-section]');
      if (root && e.state && e.state.tdcFx) load(root, window.location.href, false);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    mq.addEventListener && mq.addEventListener('change', function () { roots().forEach(function (r) { setOpen(r, false); }); });

    function init() {
      if (!document.querySelector('[data-tdc-fx-section]')) return;
      if (history.state === null || !history.state.tdcFx) history.replaceState({ tdcFx: true }, '');
      applyCols(document);
      if (document.querySelector('[data-tdc-grid]') && !document.querySelector('.tdc-totop')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tdc-totop';
        b.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>Back to top';
        document.body.appendChild(b);
      }
      onScroll();
      restore();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
